import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  memo,
  useMemo,
} from 'react'
import { Alert, Col, Collapse, Form, Row } from 'react-bootstrap'
import { colors } from '../../../../styles/colors'
import { DeleteIcon } from '../../../Icons/DeleteIcon'
import CostCenterSelect from '../../../Employees/Form/FormComponents/CostCenterSelect'
import { ArrowBigIcon } from '../../../Icons/ArrowBigIcon'
import { StyledCollapseTrigger } from '../formHelper'
import { Trans, useTranslation } from 'react-i18next'
import ArraySelect from '../../../Select/ArraySelect'
import { MdLibraryAdd } from 'react-icons/md'
import { emptyGuid } from '../../../../utils/emptyGuid'
import { cloneDeep } from 'lodash'
import StyledAddRowButton from '../../../Buttons/StyledAddRowButton'
import styled from 'styled-components'

const StyledDeleteButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 38px; /* matches input height */
  width: 44px;
  border: 1px solid ${colors.gray2};
  background-color: #fff;
  border-radius: 6px;
  cursor: pointer;
  padding: 0;
  margin-left: 0.5rem;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${colors.gray1};
  }

  svg {
    width: 18px;
    height: 18px;
  }
`
const CostCenterRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;
`

const JobFunctions = memo(
  ({
    selectableAvtivities,
    collapsible,
    activities,
    setActivitiesByKey,
    formErrors,
    resetErrorByFormKey,
  }) => {
    const template = useMemo(
      () => ({ id: emptyGuid, percentage: '', costCenter: { id: emptyGuid } }),
      []
    )
    const activitiesItems = activities.newItems
    const [invalidActivityErrors, setInvalidActivityErrors] = useState({})
    const [opened, setOpened] = useState(!collapsible)
    const ref = useRef()

    const handleClickCollapse = useCallback(() => {
      setOpened((prev) => !prev)
    }, [setOpened])

    const addRow = () => {
      const newJobs = [...activitiesItems]
      const clonedTemplate = cloneDeep(template)
      newJobs.push(clonedTemplate)
      setActivitiesByKey('newItems', newJobs)
    }

    const deleteRow = (index) => () => {
      const newJobs = [...activitiesItems]
      newJobs.splice(index, 1)
      setActivitiesByKey('newItems', newJobs)
    }

    const handleChangeFunction = (index, item) => {
      const newJobs = [...activitiesItems]
      newJobs[index]['id'] = item.id
      newJobs[index]['displayName'] = item.displayName
      setActivitiesByKey('newItems', newJobs)
    }

    const handleChangeCostCenter = (index) => (costCenter) => {
      const newJobs = [...activitiesItems]
      newJobs[index].costCenter.id = costCenter.id
      setActivitiesByKey('newItems', newJobs)
      resetErrorByFormKey(`newItems.${index}.costCenter.id`)
    }

    // const handleOnSelectPercentage = (index, precentage) => {
    //   const newJobs = [...activitiesItems]
    //   newJobs[index]['percentage'] = precentage
    //   setActivitiesByKey('newItems', newJobs)
    // }

    useEffect(() => {
      if (activitiesItems.length) {
        activitiesItems.forEach((item, index) => {
          if (item.id && item.id !== emptyGuid) {
            let selectableAvtivitiesIncludeSelected = selectableAvtivities.find(
              (activity) => activity.id === item.id
            )
            if (!selectableAvtivitiesIncludeSelected) {
              setInvalidActivityErrors((prev) => {
                prev[`${index}_blub`] = true
                return cloneDeep(prev)
              })
            } else {
              setInvalidActivityErrors((prev) => {
                prev[`${index}_blub`] = false
                return cloneDeep(prev)
              })
            }
          }
        })
      }
    }, [activitiesItems, selectableAvtivities, setInvalidActivityErrors])

    const { t } = useTranslation()
    return (
      <div ref={ref}>
        {collapsible ? (
          <StyledCollapseTrigger onClick={handleClickCollapse}>
            <h1>
              <ArrowBigIcon
                variant={opened ? 'down' : 'right'}
                color={colors.textColor}
              />
              {t('assetFormJobFunction:jobFunction')}
            </h1>
          </StyledCollapseTrigger>
        ) : (
          <h1>{t('assetFormJobFunction:jobFunction')}</h1>
        )}
        <Collapse in={opened}>
          <div className='spacing-down'>
            {activitiesItems.length === 0 && (
              <Alert variant='info'>
                {t('assetFormJobFunction:noJobFunction')}
              </Alert>
            )}
            {activitiesItems.map((item, index) => {
              return (
                <Row className='added-row' key={index}>
                  <Col sm='6' lg='3'>
                    <Form.Group style={{ marginTop: '10px' }}>
                      <Form.Label>
                        {t('assetFormJobFunction:functionName')}
                      </Form.Label>
                      <ArraySelect
                        name='id'
                        onChange={(obj) => handleChangeFunction(index, obj)}
                        value={item.id}
                        options={selectableAvtivities}
                        defaultOption={{
                          value: emptyGuid,
                          name: t('pleaseSelect'),
                        }}
                        defaultOptionIsSelectable
                        isInvalid={
                          !!formErrors[`newItems.${index}.id`] ||
                          !!invalidActivityErrors[`${index}_blub`]
                        }
                      />
                      <Form.Control.Feedback type='invalid'>
                        {formErrors[`newItems.${index}.id`] ||
                          (invalidActivityErrors[`${index}_blub`] ? (
                            <Trans
                              i18nKey='assetFormJobFunction:invalidJobFunction'
                              values={{ displayName: item.displayName }}
                            />
                          ) : null)}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col sm='6' lg='5'>
                    <Form.Group
                      style={{ marginTop: '10px', paddingBottom: '10px' }}
                    >
                      <Form.Label>
                        {t('assetFormJobFunction:costcenter')}
                      </Form.Label>

                      <CostCenterRow>
                        <div style={{ flex: 1 }}>
                          <CostCenterSelect
                            id={`newItems.${index}.costCenter`}
                            value={item.costCenter.id}
                            onChange={handleChangeCostCenter(index)}
                            isInvalid={
                              !!formErrors[`newItems.${index}.costCenter.id`]
                            }
                          />
                        </div>

                        <StyledDeleteButton
                          onClick={deleteRow(index)}
                          title={t('deleteButton')}
                        >
                          <DeleteIcon />
                        </StyledDeleteButton>
                      </CostCenterRow>
                    </Form.Group>
                  </Col>
                </Row>
              )
            })}
            <StyledAddRowButton onClick={addRow}>
              <MdLibraryAdd className='me-3' />
              {t('assetFormJobFunction:addAdditionalFunction')}
            </StyledAddRowButton>
          </div>
        </Collapse>
      </div>
    )
  }
)

export default JobFunctions
